import React from "react";
import { useEffect } from "react";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <main id="content" role="main">
      <div class="md:max-w-screen-sm text-center px-4 sm:px-6 lg:px-8 pt-24 pb-6 mx-auto">
        <h1 class="text-2xl font-bold md:text-4xl ">Terms & Policy</h1>
      </div>

      <div class="md:max-w-screen-sm lg:max-w-[992px] px-4 sm:px-6 lg:px-8 pb-12 md:pt-6 sm:pb-20 mx-auto">
        <div class="grid gap-4 md:gap-8">
          <div>
            <h2 class="text-lg sm:text-xl font-semibold mb-2 ">
              Privacy Policy
            </h2>

            <p class="mb-3 ">
              Fusion Vastras built the Fusion Vastras app as a Free app. This
              SERVICE is provided by Fusion Vastras at no cost and is intended
              for use as is.
            </p>

            <p className="mb-3">
              This page is used to inform visitors regarding our policies with
              the collection, use, and disclosure of Personal Information if
              anyone decided to use our Service.
            </p>

            <p className="mb-3">
              If you choose to use our Service, then you agree to the collection
              and use of information in relation to this policy. The Personal
              Information that we collect is used for providing and improving
              the Service. We will not use or share your information with anyone
              except as described in this Privacy Policy.
            </p>

            <p className="mb-3">
              The terms used in this Privacy Policy have the same meanings as in
              our Terms and Conditions, which are accessible at Fusion Vastras
              unless otherwise defined in this Privacy Policy.
            </p>
          </div>

          <div>
            <h2 class="text-lg sm:text-xl font-semibold mb-2 ">
              Information Collection and Use
            </h2>

            <p class="mb-3 ">
              For a better experience, while using our Service, we may require
              you to provide us with certain personally identifiable
              information, including but not limited to Fusion Vastras. The
              information that we request will be retained by us and used as
              described in this privacy policy.
            </p>

            <p className="mb-3">
              The app does use third-party services that may collect information
              used to identify you.
            </p>

            <p className="mb-3">
              Link to the privacy policy of third-party service providers used
              by the app
            </p>

            <p className="mb-3">
              Google Play Services
              <br />
              Facebook
              <br />
              Log Data
            </p>

            <p className="mb-3">
              We want to inform you that whenever you use our Service, in a case
              of an error in the app we collect data and information (through
              third-party products) on your phone called Log Data. This Log Data
              may include information such as your device Internet Protocol
              (“IP”) address, device name, operating system version, the
              configuration of the app when utilizing our Service, the time and
              date of your use of the Service, and other statistics.
            </p>
          </div>

          <div>
            <h2 class="text-lg sm:text-xl font-semibold mb-2 ">Cookies</h2>

            <p class="mb-3">
              Cookies are files with a small amount of data that are commonly
              used as anonymous unique identifiers. These are sent to your
              browser from the websites that you visit and are stored on your
              device's internal memory.
            </p>
          </div>

          <p className="mb-3">
            This Service does not use these “cookies” explicitly. However, the
            app may use third-party code and libraries that use “cookies” to
            collect information and improve their services. You have the option
            to either accept or refuse these cookies and know when a cookie is
            being sent to your device. If you choose to refuse our cookies, you
            may not be able to use some portions of this Service.
          </p>

          <div>
            <h2 class="text-lg sm:text-xl font-semibold mb-2 ">
              Service providers
            </h2>

            <h3 class="text-lg sm:text-xl font-semibold mb-2 ">
              We may employ third-party companies and individuals due to the
              following reasons:
            </h3>

            <p class="mb-3">
              To facilitate our Service;
              <br />
              To provide the Service on our behalf;
              <br />
              To perform Service-related services; or
              <br />
              To assist us in analyzing how our Service is used.
              <br />
              We want to inform users of this Service that these third parties
              have access to their Personal Information. <br />
              The reason is to perform the tasks assigned to them on our behalf.
              However, they are obligated not to disclose or use the information
              for any other purpose.
            </p>
          </div>

          <div>
            <h2 class="text-lg sm:text-xl font-semibold mb-2 ">Security</h2>

            <p class="mb-4">
              We value your trust in providing us your Personal Information,
              thus we are striving to use commercially acceptable means of
              protecting it. But remember that no method of transmission over
              the internet, or method of electronic storage is 100% secure and
              reliable, and we cannot guarantee its absolute security.
            </p>
          </div>

          <div>
            <h2 class="text-lg sm:text-xl font-semibold mb-2 ">
              Links to Other Sites
            </h2>

            <p class="mb-4">
              This Service may contain links to other sites. If you click on a
              third-party link, you will be directed to that site. Note that
              these external sites are not operated by us. Therefore, we
              strongly advise you to review the Privacy Policy of these
              websites. We have no control over and assume no responsibility for
              the content, privacy policies, or practices of any third-party
              sites or services.
            </p>
          </div>

          <div>
            <h2 class="text-lg sm:text-xl font-semibold mb-2 ">
              Children’s Privacy
            </h2>

            <p class="">
              These Services do not address anyone under the age of 13. We do
              not knowingly collect personally identifiable information from
              children under 13 years of age. In the case we discover that a
              child under 13 has provided us with personal information, we
              immediately delete this from our servers. If you are a parent or
              guardian and you are aware that your child has provided us with
              personal information, please contact us so that we will be able to
              do the necessary actions.
            </p>
          </div>
          <div>
            <h2 class="text-lg sm:text-xl font-semibold mb-2 ">
              Changes to This Privacy Policy
            </h2>

            <p class="mb-4">
              We may update our Privacy Policy from time to time. Thus, you are
              advised to review this page periodically for any changes. We will
              notify you of any changes by posting the new Privacy Policy on
              this page.
            </p>
          </div>
          <h2 class="text-lg sm:text-xl font-semibold my-2 ">
            This policy is effective as of 2023-07-12
          </h2>

          <h2 class="text-lg sm:text-xl font-semibold my-2 ">Contact</h2>

          <p className="my-2">
            If you have any questions or suggestions about our Privacy Policy,
            do not hesitate to contact us at info@Fusion Vastras.com.
          </p>
        </div>
      </div>
    </main>
  );
};

export default TermsAndConditions;
